import { render, staticRenderFns } from "./view_company.vue?vue&type=template&id=dce7ce0a"
import script from "./view_company.vue?vue&type=script&lang=js"
export * from "./view_company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports